import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import EmployeeSearch from 'dashboard/filters/employees'

// One employee column (Entered By, PO Clerk…) as a filter in the AND/OR group builder, through the
// same EmployeeSearch the column's own filter uses. With no dashboardId it stages picks in this
// leaf's state rather than saving them to the View's dashboard_employees.
const EmployeeFilterPopover = ({ column, params, setParams, onClose, onSetHandleApply, canEdit = true }) => {
  const [pending, setPending] = useState({
    employees: params.employees || [],
    excludedEmployees: params.excludedEmployees || []
  })

  const apply = () => {
    setParams((current) => ({ ...current, employees: pending.employees, excludedEmployees: pending.excludedEmployees }))
    onClose?.()
  }

  useEffect(() => {
    onSetHandleApply?.(apply)
  }, [pending]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minWidth: 360 }}>
      <div className="mb-3">
        <strong>{column.display_name || column.name}</strong>
      </div>
      <EmployeeSearch
        params={{ ...pending, section_id: column.section_id }}
        setParams={setPending}
        columnName={column.database_column_name}
        canEdit={canEdit}
      />
      <div className="d-flex justify-content-end mt-3">
        <Button variant="primary" size="sm" onClick={canEdit ? apply : onClose}>
          {canEdit ? 'Apply' : 'Close'}
        </Button>
      </div>
    </div>
  )
}

EmployeeFilterPopover.propTypes = {
  column: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  setParams: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onSetHandleApply: PropTypes.func,
  canEdit: PropTypes.bool
}

export default EmployeeFilterPopover
